import React from 'react';

import { formatNumber } from '@eika-infrastruktur/format';
import { LinkPanel } from '@eika/link-panel';

import { useConfig } from '../../defaultConfig';
import { CardAccount } from '../../generated-types';
import { useTranslation } from '../../translations';
import { format } from '../../translations/useTranslation';
import { kredittbankenTrackingIDs } from '../../utils/gtm/kredittbankenTrackingIds';
import CreditCardInfoCard from '../CreditCardInfoCard/CreditCardInfoCard';

import './CreditCardApplicationScreen.scss';

interface Props {
    creditCards: CardAccount[];
}

const CreditCardApplicationScreen: React.FC<Props> = ({ creditCards }) => {
    const translated = useTranslation().creditCardScreen;
    const {
        links: { applyForEikaEmployeeCard, applyForHigherCreditLimit, errorCreditCard, applyForCreditCard },
    } = useConfig();
    const hasEikaEmployeeCard = creditCards.find((card) => card.productName.toLowerCase().includes('eika ansatt'));
    const hasRegularCreditCard = creditCards.some((card) => !card.productName.toLowerCase().includes('eika ansatt'));

    return (
        <div className="sgw-content">
            <CreditCardInfoCard />
            {applyForHigherCreditLimit?.url && (
                <>
                    <span className="typography-subtitle-bold">{translated.cardListTitle}</span>
                    <ul className="credit-card-application__card-list">
                        {creditCards.map((card) => (
                            <>
                                <LinkPanel
                                    as="li"
                                    key={card.productName}
                                    title={card.productName}
                                    textOne={format(translated.creditLimitText, formatNumber(card.creditLimit, 0))}
                                    url={
                                        card.allowChangeToCreditLimit
                                            ? format(applyForHigherCreditLimit?.url, card.accountId.toString())
                                            : errorCreditCard?.url
                                    }
                                />
                            </>
                        ))}
                    </ul>
                </>
            )}
            {!hasEikaEmployeeCard && (
                <>
                    <span className="typography-subtitle-bold">{translated.applyForCreditCardTitle}</span>
                    <LinkPanel
                        className="credit-card-application__employee-link"
                        url={applyForEikaEmployeeCard?.url}
                        isInformation
                        title={translated.applyForEikaEmployeeTitle}
                        textOne={translated.applyForEikaEmployeeCardText}
                        data-track-id={kredittbankenTrackingIDs.applyForCreditCard}
                        data-track-linkname={translated.applyForEikaEmployeeTitle}
                    />
                </>
            )}
            {hasEikaEmployeeCard && !hasRegularCreditCard && applyForCreditCard && (
                <>
                    <span className="typography-subtitle-bold">{translated.applyForCreditCardTitle}</span>
                    <LinkPanel
                        className="credit-card-application__employee-link"
                        url={applyForCreditCard.url}
                        isInformation
                        title={translated.applyForCreditCardTitle}
                        data-track-id={kredittbankenTrackingIDs.applyForCreditCard}
                        data-track-linkname={translated.applyForCreditCardTitle}
                    />
                </>
            )}
        </div>
    );
};

export default CreditCardApplicationScreen;
